<template>
  <div class="flex-wrapper">
    <img class="logo" alt="VCK Token Counter Logo" src="@/assets/logo.png">
    <custom-button class="start-game-button">
      <router-link to="/game">{{GameInProgress ? 'Continue' : 'Start Game'}}</router-link>
    </custom-button>
    <p class="coffee-text">This website is free to use without ads. ❤️</p>
    <a class="coffee-button" href="https://www.buymeacoffee.com/creichart" target="_blank">
      <img src="@/assets/buy-me-a-coffee-logo.svg" />
    </a>
    <router-link to="/about" class="bottom-link">About</router-link>
  </div>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue'

export default {
  name: 'Home',
  components: {
    CustomButton
  },
  computed: {
    GameInProgress() {
      if (localStorage['gameInProgress'] === 'true') {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.flex-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.logo {
  margin-top: 30px;
  width: 80%;
  max-width: 360px;
  margin: 20px;
}
.start-game-button {
  margin: 40px 0;
}

.bottom-link {
font-family: 'Simonetta';
font-style: normal;
font-size: 16px;
line-height: 76.5%;
text-align: center;
color: rgba(0, 0, 0, 0.5);
margin-bottom: 30px;
margin-top: 20px;
text-decoration: none;
}

.coffee-text {
  font-family: 'Simonetta';
  font-style: normal;
  font-size: 16px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
  margin: 30px 20px 20px 20px;
}
.coffee-button {
  display: inline-block;
  background-color: white;
  padding: 10px 20px;
  margin: 0 auto;
  border-radius: 20px;
  transition: all 0.3s;
}

.coffee-button:hover {
  background-color: #FAFBF7;
}

.coffee-button img {
    width: 100%;
    height: 40px;
}
</style>
